<template>
  <h5 class="text-center">Itens Selecionados</h5>
  <div class="table-responsive">
    <table class="table table-sm table-striped fs-sm">
      <thead>
        <tr>
          <th>Centro de Custo</th>
          <th>Item</th>
          <th class="text-center">Nº Sequencial</th>
          <th class="text-center">Quantidade Medida</th>
          <th class="text-center">Preço Unitário</th>
          <th class="text-center">Valor Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in itensMeasureds" :key="index">
          <td>{{ item.costCenter }}</td>
          <td>{{ item.itemName }}</td>
          <td class="text-center">{{ item.sequentialNumber }}</td>
          <td class="text-center">{{ item.amount }}</td>
          <td class="text-center">{{ formatToCurrencyBr(item.price) }}</td>
          <td class="text-center">{{ formatToCurrencyBr(item.totalValue) }}</td>
        </tr>
        <tr v-if="itensMeasureds.length > 0" class="fw-semibold">
          <td colspan="5"><strong>Valor Total da Medição:</strong></td>
          <td class="text-center">
            {{ formatToCurrencyBr(measureTotalValue) }}
          </td>
        </tr>
        <tr v-else>
          <td class="text-center" colspan="6">Nenhum item medido</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="mt-2">
    <div v-if="xmlJustify" class="alert alert-yellow">
      <strong>Atenção:</strong> De acordo com a justificativa
      <strong>{{ xmlJustify }} </strong>, o valor da medição não é comparado,
      seguindo apenas o somatório das medições.
    </div>
    <div v-else-if="disableButtonSaveMeasure" class="alert alert-danger">
      <strong>Atenção:</strong> O valor da medição não corresponde ao valor
      indicado no XML
      <ul class="mt-2 mb-0">
        <li>
          Valor Informado no XML: {{ formatToCurrencyBr(noteValue) }} ou
          {{ formatToCurrencyBr(noteValueNet) }}
        </li>
        <li>Valor Medido: {{ formatToCurrencyBr(measureTotalValue) }}</li>
        <li>
          Diferença:
          {{ formatToCurrencyBr(Math.abs(measureTotalValue - noteValue)) }} ou
          {{ formatToCurrencyBr(Math.abs(measureTotalValue - noteValueNet)) }}
        </li>
      </ul>
    </div>
    <div v-else class="alert alert-success">
      <strong>Valores iguais:</strong> O valor da medição corresponde ao valor
      indicado no XML.
    </div>
  </div>
</template>

<script>
import { formatToCurrencyBr } from '@/utils/currency'

export default {
  name: 'MeasuredItems',

  props: {
    itensMeasureds: {
      type: Array,
      required: false,
    },
    noteValue: {
      type: Number,
      required: false,
    },
    noteValueNet: {
      type: Number,
      required: false,
    },
    measureTotalValue: {
      type: Number,
      required: true,
    },
    xmlJustify: {
      type: String,
      required: true,
    },
  },

  emits: ['canSaveMeasure'],

  data() {
    return {
      formatToCurrencyBr,
      disableButtonSaveMeasure: true,
    }
  },

  watch: {
    measureTotalValue() {
      this.isValidValue()
    },
  },

  methods: {
    isValidValue() {
      if (this.xmlJustify && this.measureTotalValue > 0) {
        this.disableButtonSaveMeasure = false
      } else if (
        parseFloat(this.noteValue) === parseFloat(this.measureTotalValue) ||
        parseFloat(this.noteValueNet) === parseFloat(this.measureTotalValue)
      ) {
        this.disableButtonSaveMeasure = false
      } else {
        this.disableButtonSaveMeasure = true
      }
      this.$emit('canSaveMeasure', this.disableButtonSaveMeasure)
    },
  },

  mounted() {
    this.isValidValue()
  },
}
</script>
